/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTrfV1TrfReportState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRF_V1_TRF_REPORT_STATE_ENTITY_NAME = 'ixc.trf.v1.TrfReport';
export const ixcTrfV1TrfReportStateEntity = new schema.Entity<IxcTrfV1TrfReportState>(IXC_TRF_V1_TRF_REPORT_STATE_ENTITY_NAME, {}, { idAttribute: 'trfReportId' });

